import React from 'react';
import PropTypes from 'prop-types';

import FormikFileInput from '@zr/components/Fields/Formik/FormikFileInput';

import './UploadAnswer.less';

const ALLOWED_MIME_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'image/png',
  'image/jpeg',
  'image/gif',
];

const ALLOWED_EXTENSIONS = ['pdf', 'doc', 'docx', 'png', 'jpg', 'jpeg', 'gif'];
const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;
const MAX_FILE_SIZE_BYTES_STRING = '10MB';

const DEFAULT_UPLOAD_PARAMETERS = {
  extensions: ALLOWED_EXTENSIONS,
  max_bytes: MAX_FILE_SIZE_BYTES,
  max_bytes_string: MAX_FILE_SIZE_BYTES_STRING,
  types: ALLOWED_MIME_TYPES,
};

const humanizeExtensions = (extensions) => extensions.map((ext) => ext.toUpperCase()).join(', ');
const formatMimeTypes = (types) => types.join(',');

export function UploadAnswer({ error, question }) {
  const formatValue = (file, result) => ({
    answer_upload: result,
    answer_upload_filename: file.name,
    answer_upload_type: file.type,
    answer_upload_size: file.size,
  });

  const required = question.is_required;

  const uploadParameters = { ...DEFAULT_UPLOAD_PARAMETERS, ...question.uploadParameters };

  const validateFile = (target) => {
    let validationError;
    const file = target && target.files ? target.files[0] : null;
    const extension = file && file.name.split('.').pop().toLowerCase();
    if (required && !file) {
      validationError = 'Please upload a file to continue.';
    } else if (file && file.size > uploadParameters.max_bytes) {
      validationError = 'Please check that your file size meets the restrictions outlined below.';
    } else if (!extension || !uploadParameters.extensions.includes(extension)) {
      validationError = 'Please check that your file type meets the restrictions outlined below.';
    }

    return validationError;
  };

  return (
    <div className={`upload_answer ${error ? 'error' : ''}`}>
      <FormikFileInput
        accept={formatMimeTypes(uploadParameters.types)}
        formatValue={formatValue}
        id={question.question_id}
        name="answerUpload"
        required={required}
        validate={validateFile}
      />
      <p className="help_text">
        {humanizeExtensions(uploadParameters.extensions)}
        {' files are supported. Maximum file size is '}
        {uploadParameters.max_bytes_string}
        .
      </p>
    </div>
  );
}

UploadAnswer.propTypes = {
  error: PropTypes.string,
  question: PropTypes.shape({
    is_required: PropTypes.bool,
    question_id: PropTypes.number,
    question_type: PropTypes.oneOf(['upload']),
    uploadParameters: PropTypes.shape({
      extensions: PropTypes.arrayOf(PropTypes.string),
      max_bytes: PropTypes.number,
      max_bytes_string: PropTypes.string,
      types: PropTypes.arrayOf(PropTypes.string),
    }),
  }).isRequired,
};

UploadAnswer.defaultProps = {
  error: '',
};

export default UploadAnswer;
